( function () {
    'use strict';
    ( function ( $ ) {
        $('.fading-headline-slider').slick({
            slideToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            infinite: false,
            arrows: false,
            dots: false,
            fade: true,
            speed: 3000,
            rows: 0,
        });
    } )( jQuery );
} )();